var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-twitter 1",
    clipPath: "url(#clip0_1778_9826)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.2654 5.00906C23.3786 5.40281 22.4279 5.66719 21.4286 5.78719C22.4486 5.17594 23.2323 4.20844 23.5998 3.05719C22.6473 3.62156 21.5879 4.03219 20.4648 4.25344C19.5648 3.29344 18.2823 2.69531 16.8629 2.69531C14.1367 2.69531 11.9261 4.90406 11.9261 7.63031C11.9261 8.01656 11.9711 8.39344 12.0554 8.75531C7.95294 8.54906 4.31732 6.58406 1.88169 3.59719C1.45607 4.32844 1.21419 5.17594 1.21419 6.07969C1.21419 7.79156 2.08419 9.30281 3.40982 10.1897C2.59982 10.1634 1.83857 9.94031 1.17294 9.57094C1.17294 9.59156 1.17294 9.61219 1.17294 9.63281C1.17294 12.0253 2.87544 14.0184 5.13107 14.4741C4.71857 14.5866 4.28169 14.6466 3.83169 14.6466C3.51294 14.6466 3.20357 14.6166 2.90169 14.5566C3.53169 16.5159 5.35419 17.9466 7.51232 17.9859C5.82482 19.3097 3.69669 20.0972 1.38294 20.0972C0.983568 20.0972 0.591694 20.0747 0.207318 20.0278C2.38982 21.4303 4.98482 22.2459 7.77294 22.2459C16.8517 22.2459 21.8167 14.7253 21.8167 8.20406C21.8167 7.99031 21.8111 7.77469 21.8036 7.56469C22.7673 6.86906 23.6036 5.99906 24.2654 5.00906Z",
    fill: "#9E9E9E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1778_9826"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.235443)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterLogo);
export default __webpack_public_path__ + "static/media/twitter-logo.f1771085fbe106597f0fccb0ff4ac8c3.svg";
export { ForwardRef as ReactComponent };